/**
 * @author       justin.jeong@zumper.com (Justin Jeong)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  pricechart reducers
 */

import type { PriceChartModule } from '@zcode/state-type'
import { combineReducers } from 'redux'
import { detailPriceChart } from './detail/index'
import { localePriceChart } from './locale/index'
import type { ActionTypes } from './types'

export const priceChartReducer = combineReducers<PriceChartModule, ActionTypes>({
  detailPriceChart,
  localePriceChart,
})
